import { render, staticRenderFns } from "./playlists-tab-card.vue?vue&type=template&id=af663f88"
import script from "./playlists-tab-card.vue?vue&type=script&lang=js"
export * from "./playlists-tab-card.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports